export const asyncLoadScript = (scriptUri: string) => {
	const scriptElement = window.document.createElement('script');
	scriptElement.async = true;
	scriptElement.src = scriptUri;

	const headElement = window.document.head;
	headElement.appendChild(scriptElement);
}

export const waitScriptLoaded = (isScriptInitializedCheck: () => boolean, intervalMs: number): Promise<void> => {
	return new Promise<void>((resolve) => {
		const intervalHandler = setInterval(() => {
			const initialIsScriptInitialized = isScriptInitializedCheck();
			if (!initialIsScriptInitialized) 
				return;
			
			resolve();
			clearInterval(intervalHandler);
		}, intervalMs);
	});
}